import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import logo from '../imagenes/logo1_bccy_blanco.svg';

const LINKEDIN = 'https://www.linkedin.com/company/bccy-colombia/jobs/?viewAsMember=true';
const YOUTUBE = 'https://www.youtube.com/channel/UCTBxxvzMkx8iEwuDEitBP8g';
const WEB_CHINA = 'https://www.bccynewpower.com/home';
const VIDEO_SOLAR = 'https://www.youtube.com/watch?v=xr3T8Zog8es';
const VIDEO_NAVIDAD = 'https://www.youtube.com/watch?v=0CNYvwO6k28';

function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-col">
            <h2>BCCY Colombia</h2>
            <p className="footer-brand-desc">
              Construimos soluciones sostenibles para el desarrollo empresarial,
              con compromiso ambiental y social.
            </p>
          </div>

          <div className="footer-col">
            <h2>Sobre Nosotros</h2>
            <ul className="footer-list">
              <li>
                <a className="footer-link" href={WEB_CHINA} target="_blank" rel="noopener noreferrer">
                  Casa Matriz Web China
                  <i className="fas fa-external-link-alt" />
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h2>Contacto</h2>
            <ul className="footer-list">
              <li>
                <Link className="footer-link" to="/contactc">
                  BCCY Córdoba
                </Link>
              </li>
              <li>
                <Link className="footer-link" to="/contacth">
                  BCCY Holding
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h2>Videos</h2>
            <ul className="footer-list">
              <li>
                <a className="footer-link" href={VIDEO_SOLAR} target="_blank" rel="noopener noreferrer">
                  Proyecto Energia Solar
                  <i className="fas fa-external-link-alt" />
                </a>
              </li>
              <li>
                <a className="footer-link" href={VIDEO_NAVIDAD} target="_blank" rel="noopener noreferrer">
                  Feliz Navidad BCCY
                  <i className="fas fa-external-link-alt" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <Link to="/" className="footer-logo">
            <img src={logo} alt="BCCY" className="footer-logo-image" />
          </Link>

          <small className="footer-rights">BCCY 2026</small>

          <div className="footer-social">
            <a className="footer-social-link" href={YOUTUBE} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <i className="fab fa-youtube" />
            </a>
            <a className="footer-social-link" href={LINKEDIN} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i className="fab fa-linkedin" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
